import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import ICONS from 'components/Icons';
import { Button, Heading, Text } from 'components/chroma';
import { SCREEN } from 'scenes/common/types/screen';

const CarImage = styled.img`
  height: 4rem;
  @media (min-width: ${SCREEN.SMALL}px) {
    height: 5rem;
  }
`;

const VehicleNotFound: FunctionComponent<{
  onClick: () => void;
}> = ({ onClick }) => (
  <>
    <CarImage
      src={ICONS.DEFAULT.MOTOR}
      tabIndex={-1}
      alt="Vehicle not found graphic"
    />
    <Heading size={3} margin={{ top: 2 }}>
      Sorry we could not find the car through the registration search.
    </Heading>
    <Text>
      Unfortunately, we have been unable to find the car and you have reached
      the maximum number of registration searches permitted.
    </Text>
    <Button primary size="lg" maxWidth onClick={onClick}>
      Select the car manually
    </Button>
  </>
);

export default VehicleNotFound;
